const accordionWrapper = document.querySelectorAll(".accordion_wrapper");
if (accordionWrapper) {
  accordionWrapper.forEach(accord => {
    accord.addEventListener("click", function (event) {
    if (!event.target.closest(".accordion_title")) return;
    const faqTitle = event.target.closest(".accordion_title");
    const buttonToggle = faqTitle.querySelector(".accord_icons");
    const containerContent = faqTitle.nextElementSibling;
    if (!buttonToggle || !containerContent) return;
    document.querySelectorAll(".accord_icons").forEach((toggle) => {
      if (toggle !== buttonToggle) toggle.classList.remove("open");
    });
    document.querySelectorAll(".accordion_content_wrapper").forEach((content) => {
      if (content !== containerContent) {
        content.style.maxHeight = null;
        content.classList.remove("open");
      }
    });
    buttonToggle.classList.toggle("open");
    containerContent.classList.toggle("open");
    if (containerContent.classList.contains("open")) {
      containerContent.style.maxHeight = `${containerContent.scrollHeight}px`;
    } else {
      containerContent.style.maxHeight = null;
    }
  });
  }) 
}
